import React, { Suspense } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import ErrorPage from "@components/error-page";

import Home from "./pages/home";
const PrivacyPage = React.lazy(() => import("./pages/privacy"));
const JobPage = React.lazy(() => import("./pages/job"));
const PeptideJobPage = React.lazy(() => import("./pages/peptide-job"));
const JobDetailPage = React.lazy(() => import("./pages/job-detail"));
import PromotionPage from "./pages/promotion";
import ReportPage from "./pages/report";
import ReportV2Page from "./pages/report/report-v2";
import GalleryPage from "./pages/gallery";

import NavLayout from "@layouts/nav-layout";

const router = createBrowserRouter([
  {
    path: "",
    element: <NavLayout />,
    children: [
      // { index: true, element: <Navigate to="/home" replace /> },
      { index: true, element: <Home />, errorElement: <ErrorPage /> },
      {
        path: "/terms",
        element: (
          <Suspense>
            <PrivacyPage />
          </Suspense>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: "/home",
        element: <Home />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/job",
        element: (
          <Suspense>
            <JobPage />
          </Suspense>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: "/peptide-job",
        element: (
          <Suspense>
            <PeptideJobPage />
          </Suspense>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: "/job-detail/:id",
        element: (
          <Suspense>
            <JobDetailPage />
          </Suspense>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: "/promotion",
        element: <PromotionPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/gallery",
        element: <GalleryPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/report",
        element: <ReportPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/report-v3",
        element: <ReportPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/report-v2",
        element: <ReportV2Page />,
        errorElement: <ErrorPage />,
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);

export default router;
